export const SAMPLE_EMAIL = `From: Anil Mehta <anil.mehta@shreebalajieng.co.in>
To: payables@acmecorp.in
Subject: Request for release of 40% advance - PO/ACM/2024/0771

Dear Ms. Nandini,

As discussed over call, kindly release the 40% advance payment of Rs. 4,86,000/- against
PO/ACM/2024/0771 for the fabrication of the CNC jig fixtures. Our earlier pending invoice
SBE/INV/2024/1187 dated 28-Feb-2024 (Rs. 1,24,560/-) may also please be cleared in the same run.

For your ready reference, our particulars once again:

Shree Balaji Engineering Works Pvt. Ltd.
Contact: Mr. Rajesh Kumar Sharma, +91 98765 43210, accounts@shreebalajieng.co.in
Plot No. 42, Phase-II, GIDC Industrial Estate, Vatva, Ahmedabad, Gujarat - 382445
PAN aabcs1429k | GSTIN 24aabcs1429k1zp
Bank: HDFC Bank, A/c 50200034567891, IFSC hdfc0001234, Vatva GIDC branch

Also please onboard our sister concern for the packaging supply:
Green Earth Packaging Industries, contact Mr. S. Karthikeyan, +91-90031-45678,
karthik@greenearthpack.com, No. 18/3, SIDCO Industrial Estate, Guindy, Chennai,
Tamil Nadu 600032. PAN AKGPP8812M, GSTIN 33AKGPP8812M1ZR. State Bank of India,
A/c 38291047562, IFSC SBIN0011223, Guindy branch. Full & final settlement of invoice
GEP/1123 dated 02-Feb-2024.

Regards,
Anil Mehta
Sr. Manager - Accounts`;
